import React, { useEffect, useState } from 'react';
import { TeamInfo } from '../TeamInfo';
import { apexPitSeconds, formatElapsed } from '../analytics/elapsed';
import './DriverTimeStatus.css';

interface DriverTimeStatusProps {
  team: TeamInfo;
}

/**
 * Shows the current driver's time on track, or — when the kart is in the pit —
 * the live elapsed pit time with a clear PIT marker.
 */
export const DriverTimeStatus: React.FC<DriverTimeStatusProps> = ({ team }) => {
  const inPit = team.inBox;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!inPit) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [inPit]);

  if (inPit) {
    // Apex's pit stopwatch, then our own timing of the stop. boxTimeRemaining
    // used to be the fallback, but the `to` channel that feeds it is empty in
    // every in-pit sample of a recorded event, so it never showed anything.
    const apexPit = apexPitSeconds(team.onTrackTime);
    const elapsed =
      apexPit != null
        ? formatElapsed(apexPit * 1000)
        : team.pitEntryTime != null
          ? formatElapsed(now - team.pitEntryTime)
          : '';
    return (
      <span className="dts dts--pit" title="In pit">
        <span className="dts-pit-tag">PIT</span>
        {elapsed && <span className="dts-time">{elapsed}</span>}
      </span>
    );
  }

  if (team.onTrackTime) {
    return (
      <span className="dts dts--track" title="Time on track">
        <span className="dts-track-icon" aria-hidden="true">⏱</span>
        <span className="dts-time">{team.onTrackTime}</span>
      </span>
    );
  }

  return null;
};

export default DriverTimeStatus;
